var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 60,
    viewBox: "0 0 47 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1997_8484)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1997_8484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.18 11.7466H38.7811C41.9944 11.7466 44.626 14.7106 44.626 18.3394V52.5222C44.626 56.1787 42.0221 59.115 38.7811 59.115H7.22988C4.01659 59.115 1.38501 56.151 1.38501 52.5222V18.3394C1.38501 14.6829 3.98889 11.7466 7.22988 11.7466H11.108",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9473 7.56368C28.9473 4.43349 26.3989 1.88501 23.2687 1.88501H22.7146C19.5845 1.88501 17.036 4.43349 17.036 7.56368C13.9058 7.56368 11.385 10.0845 11.385 13.2147V15.6523H34.5983V13.2147C34.5983 10.0845 32.0775 7.56368 28.9473 7.56368Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 46.8712H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 36.5665H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 26.2617H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1997_8484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.9834,
    height: 60,
    fill: "white",
    transform: "translate(0.508301)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1997_8484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.9834,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.755871bee62ae1505a31c9afb5640293.svg";
export { ForwardRef as ReactComponent };